import { render, staticRenderFns } from "./AskAnalyst.vue?vue&type=template&id=7bc9bf9a"
import script from "./AskAnalyst.vue?vue&type=script&lang=js"
export * from "./AskAnalyst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports